/* Authentication */
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const LOGIN_LOADING = 'LOGIN_LOADING'
export const LOGOUT = 'LOGOUT'

/* App */
export const LOAD_STARTED = 'LOAD_STARTED'

/* MQTT */
export const MQTT_NEW_CLIENT = 'MQTT_NEW_CLIENT'
export const MQTT_NEW_MESSAGE = 'MQTT_NEW_MESSAGE'

/* Condominiums */
export const LOAD_CONDOMINIUM_SUCCESS = 'LOAD_CONDOMINIUM_SUCCESS'
export const LOAD_CONDOMINIUM_ERROR = 'LOAD_CONDOMINIUM_ERROR'
export const LOAD_CONDOMINIUM_LOADING = 'LOAD_CONDOMINIUM_LOADING'

/* Buildings */
export const LOAD_BUILDINGS_SUCCESS = 'LOAD_BUILDINGS_SUCCESS'
export const LOAD_BUILDINGS_ERROR = 'LOAD_BUILDINGS_ERROR'
export const LOAD_BUILDINGS_LOADING = 'LOAD_BUILDINGS_LOADING'

/* Cisterns */
export const LOAD_CISTERNS_SUCCESS = 'LOAD_CISTERNS_SUCCESS'
export const LOAD_CISTERNS_ERROR = 'LOAD_CISTERNS_ERROR'
export const LOAD_CISTERNS_LOADING = 'LOAD_CISTERNS_LOADING'

/* Hubs */
export const LOAD_HUBS_SUCCESS = 'LOAD_HUBS_SUCCESS'
export const LOAD_HUBS_ERROR = 'LOAD_HUBS_ERROR'
export const LOAD_HUBS_LOADING = 'LOAD_HUBS_LOADING'

export const LOAD_HUB_STATUS_SUCCESS = 'LOAD_HUB_STATUS_SUCCESS'
export const LOAD_HUB_STATUS_ERROR = 'LOAD_HUB_STATUS_ERROR'
export const LOAD_HUB_STATUS_LOADING = 'LOAD_HUB_STATUS_LOADING'

/* Modules */
export const LOAD_MODULES_SUCCESS = 'LOAD_MODULES_SUCCESS'
export const LOAD_MODULES_ERROR = 'LOAD_MODULES_ERROR'
export const LOAD_MODULES_LOADING = 'LOAD_MODULES_LOADING'

/* Informations */
export const LOAD_INFORMATIONS_SUCCESS = 'LOAD_INFORMATIONS_SUCCESS'
export const LOAD_INFORMATIONS_ERROR = 'LOAD_INFORMATIONS_ERROR'
export const LOAD_INFORMATIONS_LOADING = 'LOAD_INFORMATIONS_LOADING'

export const LOAD_INFORMATION_UPDATES_SUCCESS = 'LOAD_INFORMATION_UPDATES_SUCCESS'
export const LOAD_INFORMATION_UPDATES_ERROR = 'LOAD_INFORMATION_UPDATES_ERROR'
export const LOAD_INFORMATION_UPDATES_LOADING = 'LOAD_INFORMATION_UPDATES_LOADING'

/* Notifications */
export const LOAD_NOTIFICATIONS_SUCCESS = 'LOAD_NOTIFICATIONS_SUCCESS'
export const LOAD_NOTIFICATIONS_ERROR = 'LOAD_NOTIFICATIONS_ERROR'
export const LOAD_NOTIFICATIONS_LOADING = 'LOAD_NOTIFICATIONS_LOADING'

export const HANDLE_NOTIFICATIONS = 'HANDLE_NOTIFICATIONS'
export const CLICK_NOTIFICATION = 'CLICK_NOTIFICATION'
export const LAUNCH_NOTIFICATION = 'LAUNCH_NOTIFICATION'

/* Commands */
export const LOAD_COMMANDS_SUCCESS = 'LOAD_COMMANDS_SUCCESS'
export const LOAD_COMMANDS_ERROR = 'LOAD_COMMANDS_ERROR'
export const LOAD_COMMANDS_LOADING = 'LOAD_COMMANDS_LOADING'

export const LOAD_COMMAND_LOGS_SUCCESS = 'LOAD_COMMAND_LOGS_SUCCESS'
export const LOAD_COMMAND_LOGS_ERROR = 'LOAD_COMMAND_LOGS_ERROR'
export const LOAD_COMMAND_LOGS_LOADING = 'LOAD_COMMAND_LOGS_LOADING'

/* Tanks */
export const LOAD_TANKS_SUCCESS = 'LOAD_TANKS_SUCCESS'
export const LOAD_TANKS_ERROR = 'LOAD_TANKS_ERROR'
export const LOAD_TANKS_LOADING = 'LOAD_TANKS_LOADING'

/* Bombs */
export const LOAD_BOMBS_SUCCESS = 'LOAD_BOMBS_SUCCESS'
export const LOAD_BOMBS_ERROR = 'LOAD_BOMBS_ERROR'
export const LOAD_BOMBS_LOADING = 'LOAD_BOMBS_LOADING'

/* Bomb Models */
export const LOAD_BOMB_MODELS_SUCCESS = 'LOAD_BOMB_MODELS_SUCCESS'
export const LOAD_BOMB_MODELS_ERROR = 'LOAD_BOMB_MODELS_ERROR'
export const LOAD_BOMB_MODELS_LOADING = 'LOAD_BOMB_MODELS_LOADING'

/* Manufacturers */
export const LOAD_MANUFACTURERS_SUCCESS = 'LOAD_MANUFACTURERS_SUCCESS'
export const LOAD_MANUFACTURERS_ERROR = 'LOAD_MANUFACTURERS_ERROR'
export const LOAD_MANUFACTURERS_LOADING = 'LOAD_MANUFACTURERS_LOADING'

/* UI */
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR'
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR'



/** WEBPACK FOOTER **
 ** ./src/actions/actionTypes.js
 **/